import React from 'react';
import { Typography, Link, Alert } from '@one-thd/sui-atomic-components';
import { RETURN_METHOD, ReturnMethodType } from '@src/constants/general';
import ReturnReviewCard from '@src/components/shared/summary-cards/ReturnReviewCard';
import ItemDetails from '@src/components/shared/summary-cards/ItemDetails';
import { ItemToReturn } from '@src/models/returns';
import LORPContactDetails from '../lorp/lorp-contact-details/LORPContactDetails';
import { ILORPContactDetails } from '../lorp/lorp-contact-details/LORPContactDetailsStep';

interface SummaryReturnCardProps {
  method: ReturnMethodType;
  header: string;
  items: ItemToReturn[];
  handleReturnInstructionsClick: () => void;
  contactDetails?: ILORPContactDetails;
}

const SummaryReturnCard = ({
  method,
  header,
  items,
  handleReturnInstructionsClick,
  contactDetails,
}: SummaryReturnCardProps) => {
  return (
    <ReturnReviewCard key={method} header={header}>
      {method === RETURN_METHOD.LORP && (
        <div className="sui-mb-6">
          <Alert status="info">
            <Typography variant="body-base">
              Check your email for a scheduling link from Hub Group for each
              item
            </Typography>
          </Alert>
        </div>
      )}
      {items.map((item: ItemToReturn, index: number) => (
        <ItemDetails key={`${item.lineItemId}-${index}`} item={item} />
      ))}
      <Link onClick={handleReturnInstructionsClick}>
        View Return Instructions
      </Link>
      {method === RETURN_METHOD.LORP && (
        <div className="sui-mt-6">
          <hr />
          <LORPContactDetails contactDetails={contactDetails} />
        </div>
      )}
    </ReturnReviewCard>
  );
};

export default SummaryReturnCard;
